var React = require('react');

function LoaderInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9381.77,3407.83v-57h30.8v-31l96.2,30.9.2,57.1h-15.9v-29a7.83,7.83,0,1,0-15.65,0v29H9461v-29a7.83,7.83,0,1,0-15.65,0v29h-32.77","transform":"translate(-9378.77 -3315.71)","id":"strokeLoader","fill":"white"}));
}

LoaderInline.defaultProps = {"viewBox":"0 0 133.21 95.11","width":"134","height":"95","fill":"none","className":"svg"};

module.exports = LoaderInline;

LoaderInline.default = LoaderInline;
